import { Box, Typography, Paper, CardMedia } from "@mui/material";
import { AppColor } from '../../../../types/Constants';
import Arrow2SVG from "./vectors/Arrow2.svg";
import Arrow3SVG from "./vectors/Arrow3.svg";

const TutorialPage = () => {

    return (
        <div
            id="scrollable-container"
            style={{ overflowY: "auto", height: "calc(100vh - 75px)" }}
        >
        <Typography sx={{ mt: 1, fontSize: 30, fontWeight: 600, dislay: "flex", justifyContent: "center" }} gutterBottom>
            Welcome to Skidattl!
        </Typography>
        <Box sx={{ display: "flex", width: "100%", gap: 4, mt: 6 }}>
            <Paper elevation={3} sx={{ backgroundColor: "white", width: "50%", }}>
                <Box sx={{ display: "flex", gap: 10, padding: 4, zIndex: 2 }}>
                    <Box sx={{ 
                        display: "flex", 
                        flexDirection: "column", 
                        position: "relative",
                        zIndex: 10
                    }}>
                        <img src={Arrow2SVG} style={{ width: "25%", position: "absolute", transform: "translateX(-15%)", top: "-45px"}}/>
                        <Box sx={{ }}>
                        <Typography sx={{ color: AppColor.darkBrand, fontSize: 20, fontWeight: 600, mb: 2 }}>Create a Skidattl Experience</Typography>
                        <Typography sx={{ fontSize: 16, fontWeight: 500 }}>To get started, click the + New Experience button here.</Typography>
                        </Box>
                    </Box>
                </Box>
            </Paper>
            <Paper elevation={3} sx={{ backgroundColor: "white", width: "50%" }}>
                <Box sx={{ gap: 2, padding: 4, position: "relative" }}>
                        <Typography sx={{ color: AppColor.darkBrand, fontSize: 20, fontWeight: 600, mb: 2 }}>Manage Your Account</Typography>
                        <Typography sx={{ fontSize: 16, fontWeight: 500 }}>Manage your account by clicking on the drop down menu above. Be sure to select the right Subscription Tier for you!</Typography>
                    <img src={Arrow3SVG} 
                        style={{ 
                            width: "7vw",
                            position: "absolute", 
                            top: "-70px", 
                            right: "0px",
                            transform: "translateX(-10%)",
                        }}
                    />
                </Box>
            </Paper>
        </Box>
        <Box sx={{ width: "75%", height: "100%", mt: 4 }}>
                <Paper elevation={3} sx={{ backgroundColor: "white", borderRadius: 2 }}>
                <CardMedia
                    component="iframe"
                    src="https://www.youtube.com/embed/dNb04cRbVrc?si=QexDujezjHDWkS1B"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    sx={{ height: "70vh", border: 0, borderRadius: 2 }}
                />
                </Paper>
        </Box>
        </div>
    );
};

export default TutorialPage;
